/* eslint-disable */

import Vue from "vue";
import Router from "vue-router";
import * as auth from "@/middleware/auth.js";

const compLogin = () => import("@/components/auth/Login.vue");
const compMainDashboard = () => import("@/components/dashboard/Main.vue");
const compTimeline = () => import("@/components/timeline/Main.vue");
const compProfile = () => import("@/components/profile/Main.vue");
const compChangePassword = () => import("@/components/profile/ChangePassword.vue");
const compVacancy = () => import("@/components/vacancy/Main.vue");
const compSearchFriend = () => import("@/components/searchFriends/Main.vue");
const compSearch = () => import("@/components/search/Main.vue");
const compFriend = () => import("@/components/friends/Main.vue");
const compDashboard = () => import("@/components/dashboard/Dashboard.vue");
const compUserDetail = () => import("@/components/friends/Profile.vue");
const compNotification = () =>
  import("@/components/notification/NotificationAll.vue");
const compMessages = () => import("@/components/messages/messagelist.vue");
const compJobs = () => import("@/components/jobs/Main.vue");
const compJobsDetail = () => import("@/components/jobs/DetailJob.vue");
const compCompanyDetail = () => import("@/components/jobs/DetailCompany.vue");
const compSavedJob = () => import("@/components/jobs/SavedJob.vue");
const compAppliedJob = () => import("@/components/jobs/AppliedJob.vue");
const compScheduleJob = () => import("@/components/jobs/Schedule.vue");

const compUpdateProfile = () =>
  import("@/components/profile/UpdateProfile.vue");

Vue.use(Router);

function nextFactory(context, middlewara, index) {
  const subsequentMiddleware = middlewara[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);

    const nextMiddleware = nextFactory(context, middlewara, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

const dotenv = require("dotenv");
// console.log(dotenv.config())

// const router = new Router({
//   mode: 'history',
//   base: '/',
//   routes: [
//     {
//       path: process.env.SUBDIR,
//       component: compMainDashboard,
//       redirect: process.env.SUBDIR + '/timeline',
//       children: [
//         {
//           name: 'Dashboard',
//           path: 'dashboard',
//           meta: {
//             middleware: auth.Login
//           },
//           component: compDashboard
//         },
//         {
//           path: 'timeline',
//           name: 'Timeline',
//           meta: {
//             middleware: auth.Login
//           },
//           component: compTimeline
//         },
//         {
//           path: 'profile',
//           name: 'Profile',
//           meta: {
//             middleware: auth.Login
//           },
//           component: compProfile
//         },
//         {
//           path: 'vacancy',
//           name: 'Vacancy',
//           component: compVacancy
//         },
//         {
//           path: 'friends',
//           name: 'Friend',
//           meta: {
//             middleware: auth.Login
//           },
//           component: compFriend
//         },
//         {
//           path: 'friend/search',
//           name: 'FriendSearch',
//           meta: {
//             middleware: auth.Login
//           },
//           component: compSearch
//         },
//         {
//           path: 'user/:id',
//           name: 'userdetail',
//           meta: {
//             middleware: auth.Login
//           },
//           component: compUserDetail,
//           props: true
//         },
//         {
//           path: 'messages',
//           name: 'Messages',
//           meta: {
//             middlewara: auth.Login
//           },
//           component: compMessages
//         },
//         {
//           path: 'notifications',
//           name: 'Notifications',
//           meta: {
//             middleware: auth.Login
//           },
//           component: compNotification
//         }
//       ]
//     },
//     {
//       path: process.env.SUBDIR + '/login',
//       name: 'Login',
//       component: compLogin
//     },
//     {
//       path: '*',
//       redirect: '/login'
//     }
//   ]
// })

const router = new Router({
  history: true,
  mode: "history",
  base: process.env.SUBDIR,
  routes: [
    {
      path: "/",
      component: compMainDashboard,
      redirect: "/timeline",
      children: [
        {
          name: "Dashboard",
          path: "dashboard",
          meta: {
            middleware: auth.Login
          },
          component: compDashboard
        },
        {
          path: "timeline",
          name: "Timeline",
          meta: {
            middleware: auth.Login
          },
          component: compTimeline
        },
        {
          path: "profile",
          name: "Profile",
          meta: {
            middleware: auth.Login
          },
          component: compProfile
        },
        {
          path: "changePassword",
          name: "ChangePassword",
          meta: {
            middleware: auth.Login
          },
          component: compChangePassword
        },
        {
          path: "profile/update",
          name: "UpdateProfile",
          meta: {
            middleware: auth.Login
          },
          component: compUpdateProfile
        },
        {
          path: "vacancy",
          name: "Vacancy",
          component: compVacancy
        },
        {
          path: "friends",
          name: "Friend",
          meta: {
            middleware: auth.Login
          },
          component: compFriend
        },
        {
          path: "jobs",
          name: "Jobs",
          meta: {
            middlewara: auth.Login
          },
          component: compJobs
        },
        {
          path: "jobs/detail/:id",
          name: "JobsDetail",
          meta: {
            middlewara: auth.Login
          },
          component: compJobsDetail,
          props: true
        },
        {
          path: "jobs/company/:username",
          name: "CompanyDetail",
          meta: {
            middlewara: auth.Login
          },
          component: compCompanyDetail,
          props: true
        },
        {
          path: "jobs/save",
          name: "SavedJob",
          meta: {
            middlewara: auth.Login
          },
          component: compSavedJob
        },
        {
          path: "jobs/schedule",
          name: "ScheduleJob",
          meta: {
            middlewara: auth.Login
          },
          component: compScheduleJob
        },
        {
          path: "jobs/progress",
          name: "ProgressJob",
          meta: {
            middlewara: auth.Login
          },
          component: compAppliedJob
        },
        {
          path: "friend/search",
          name: "FriendSearch",
          meta: {
            middleware: auth.Login
          },
          component: compSearchFriend
        },
        {
          path: "search/:keyword?",
          name: "Search",
          meta: {
            middlewara: auth.Login
          },
          component: compSearch,
          props: true
        },
        {
          path: "user/:id",
          name: "userdetail",
          meta: {
            middleware: auth.Login
          },
          component: compUserDetail,
          props: true
        },
        {
          path: "messages/:userid?",
          name: "Messages",
          meta: {
            middleware: auth.Login
          },
          component: compMessages,
          props: true
        },
        {
          path: "notifications",
          name: "Notifications",
          meta: {
            middleware: auth.Login
          },
          component: compNotification
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: compLogin
    },
    {
      path: "*",
      redirect: "/login"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }

  const middleware = Array.isArray(to.meta.middlewara)
    ? to.meta.middleware
    : [to.meta.middleware];

  const context = {
    from,
    next,
    router,
    to
  };

  const nextMiddleware = nextFactory(context, middleware, 1);
  return middleware[0]({ ...context, next: nextMiddleware });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js